import React from "react";

const Fundings = () => {
  return (
    <div className="container my-5">
      <div className="heading">Funding</div>
      <hr />
      <div className="textAlign">
        <div>The Metya research group gratefully acknowledges its current and past sponsors.</div>
        <h4 className="mt-4 text-bold">From Government Agencies</h4>

        <li>
        Enhanced the Gas Hydrate Formation by Antifreeze Molecules: Applications in Gas Storage and Energy Recovery, SRG-SERB, 2022-2024, Rs 30 lakhs
        </li>

        <h4 className="mt-4 text-bold">From Industry</h4>
        <li>
        </li>
        <br />
      </div>
    </div>
  );
};

export default Fundings;
